export interface ConfigurationLabelValue {
	value: string;
	excludedFromDashboard?: boolean;
}

export interface ConfigurationLabel {
	showAsFilter?: boolean;
	label: string;
	displayName?: string;
	values: (string | ConfigurationLabelValue)[];
}

export interface PlatformConfiguration extends Record<string, unknown> {
	ADDITIONAL_LABELS?: ConfigurationLabel[];
	CORE_LABELS?: ConfigurationLabel[];
	DEV_TOGGLES?: {
		ENABLE_NEW_PLATFORM_DASHBOARD?: boolean;
		ENABLE_MFA_NEW_PLATFORM?: boolean;
		ENABLE_MOBILE_SDK_NEW_PLATFORM?: boolean;
		ENABLE_WEB_SDKS_BULK_EDIT: boolean;
		ENABLE_DEFAULT_JIRA_LABELS?: boolean;
	};
}

export interface LabelsExcludedFromDashboard {
	[labelKey: string]: Array<{ value: string; label: string }>;
}

export const isConfigurationLabel = (value: unknown): value is ConfigurationLabel => {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const obj = value as Record<string, unknown>;
	return (
		'label' in obj && typeof obj.label === 'string' && 'values' in obj && Array.isArray(obj.values)
	);
};

export const isPlatformConfiguration = (value: unknown): value is PlatformConfiguration => {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const obj = value as Record<string, unknown>;
	return (
		('ADDITIONAL_LABELS' in obj && Array.isArray(obj.ADDITIONAL_LABELS)) ||
		('CORE_LABELS' in obj && Array.isArray(obj.CORE_LABELS))
	);
};
